module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-vod-19-years.4222da8b.svg";